/*
 * sts-article-v6.js — what the prototype v6 article does that CSS cannot
 * (handoff 8.3 and 1.4; LIB-5, LIB-6, LIB-7). Deferred, article templates only:
 * sections/sts-article.liquid and the lower half of sections/sts-bloggle-v4.liquid.
 *
 *   1. "In this article". Every link lands on its heading through STS.jump
 *      (assets/sts-jump.js, the theme's one in-page jump): smooth scroll, the
 *      header's MEASURED height as the offset (the prototype's fixed 84px is its
 *      72px header; the v4 phone header is taller and its strip can wrap), a
 *      re-measure and correction once the scroll settles (lazy images above a
 *      heading grow on the way), then focus on the heading. Reduced motion jumps.
 *      Bloggle binds its own handler on each of its links: a 1-second scroll with
 *      a 0px offset, which parks the heading under a sticky header. This listener
 *      runs in the capture phase on the document, so it sees the click first and
 *      stops it there; neither Bloggle's handler nor sts-jump's delegated one
 *      runs for a list link. Without sts-jump.js the heading is scrolled into
 *      view, where html's scroll-padding-top still clears the header.
 *
 *   2. Copy link. Copies the canonical link (the share row carries it; never
 *      location.href, which can hold a preview id or tracking parameters) and
 *      confirms in the button itself, "Link copied", plus the row's status line
 *      for screen readers. No toast (v6 1.5).
 *
 *   3. Add to cart in the "Dr. Baumann recommends" callout. The form posts to
 *      /cart/add without JavaScript; with it, the add happens in place, the
 *      button says "Added" and the status line offers the cart, and the cart is
 *      announced the way the collection quick-add announces it (sts:cart:added
 *      with the line, then sts:cart:updated and theme:cart:change with the whole
 *      cart) so the header count follows. A refusal that Shopify explains (sold
 *      out, a quantity limit) is shown in the status line; any other failure
 *      falls back to the ordinary form post, so the reader is never stuck.
 *      v6.1 §5b: for a typed reader it is wrong for, "Add to cart anyway"
 *      opens "Not for your skin type" first (askAnyway).
 */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var TOC_LINK = '.bggle_table-of-content a[href^="#"],[data-sts-art-toc] a[href^="#"],[data-sts-article-toc] a[href^="#"]';

  function reduced() {
    return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // --------------------------------------------------- 1. "In this article"

  function targetOf(link) {
    var id = link.getAttribute('href').slice(1);
    try { id = decodeURIComponent(id); } catch (e) { /* keep it raw */ }
    if (!id) return null;
    return d.getElementById(id) ||
      d.querySelector('.bggle--block[section-id="' + id.replace(/["\\]/g, '') + '"]');
  }

  /* Only when assets/sts-jump.js is missing from the page. */
  function plainJump(el) {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest && e.target.closest(TOC_LINK);
    if (!link) return;
    var el = targetOf(link);
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    var jump = w.STS && w.STS.jump;
    if (!(typeof jump === 'function' && jump(el))) plainJump(el);
    if (el.id && w.history && w.history.replaceState) {
      try { w.history.replaceState(w.history.state, '', '#' + el.id); } catch (err) { /* sandboxed frame */ }
    }
  }, true);

  // --------------------------------------------------------- 2. Copy link

  function copyText(text) {
    if (navigator.clipboard && w.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var area = d.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      d.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = d.execCommand('copy'); } catch (e) { ok = false; }
      d.body.removeChild(area);
      if (ok) resolve(); else reject(new Error('copy refused'));
    });
  }

  d.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-sts-art-copy]');
    if (!btn) return;
    var row = btn.closest('[data-sts-art-share]');
    var status = row && row.querySelector('[data-sts-art-copy-status]');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    var url = btn.getAttribute('data-url') || w.location.href.split('#')[0];

    function say(text, done) {
      btn.textContent = text;
      if (done) btn.setAttribute('data-done', ''); else btn.removeAttribute('data-done');
      if (status) status.textContent = text;
      w.clearTimeout(btn.__stsT);
      btn.__stsT = w.setTimeout(function () {
        btn.textContent = label;
        btn.removeAttribute('data-done');
        if (status) status.textContent = '';
      }, 2500);
    }

    copyText(url).then(function () {
      say('Link copied', true);
    }, function () {
      say('Could not copy', false);
    });
  });

  // ------------------------------------------- 3. the callout's Add to cart

  function announceCart(base) {
    return w.fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var detail = { cart: cart };
        d.dispatchEvent(new CustomEvent('sts:cart:updated', { detail: detail }));
        d.dispatchEvent(new CustomEvent('theme:cart:change', { detail: detail }));
      })
      .catch(function () { /* the add itself succeeded; a stale count is harmless */ });
  }

  /* v6.1 §5b: "Add to cart anyway" asks first, as the product page does
     (STS.popups.notFor: the ! octagon, Dr. Baumann's reason behind "Note from
     Dr. Baumann ▾", 1.2). Resolves true to add. Nothing is ever blocked
     (04-Q31); the line then carries _sts_not_for_type. */
  var SUBS = { S1: 'Acne', S2: 'Redness', S3: 'Stinging', S4: 'Allergic' };
  function missingSubs(box) {
    var raw = null, list;
    try { raw = w.localStorage.getItem('customerSensitivityList'); } catch (e) { raw = null; }
    try { list = JSON.parse(raw); } catch (e) { list = String(raw || '').split(','); }
    var carried = ' ' + (box.getAttribute('data-sts-sens') || '') + ' ';
    return [].concat(list || []).map(function (s) {
      s = String(s).trim();
      for (var k in SUBS) { if (s.toUpperCase() === k || s.toLowerCase() === SUBS[k].toLowerCase()) return k; }
      return '';
    }).filter(function (k) { return k && carried.indexOf(' ' + k + ' ') < 0; }).map(function (k) { return SUBS[k]; });
  }
  function askAnyway(box) {
    var sub = box.getAttribute('data-sts-fit') === 'subtype';
    var miss = sub ? missingSubs(box) : [];
    /* v6.2 §11: the product's own note for the barred letter (data-sts-notes). */
    var own = null;
    try { own = JSON.parse(box.getAttribute('data-sts-notes') || 'null'); } catch (e) { own = null; }
    var why = sub && miss.length ? 'Not approved for the ' + miss.join(', ') + '-prone form of sensitive skin.'
      : (own && own[box.getAttribute('data-sts-bar')]) || 'Dr. Baumann has not approved this product for your Baumann Skin Type.';
    var P = w.STS && w.STS.popups;
    if (!P || !P.dialog || !P.enqueue) return Promise.resolve(w.confirm(why + ' Add it to your cart anyway?'));
    return new Promise(function (resolve) {
      P.enqueue({
        id: 'sts-art-anyway',
        open: function (done) {
          P.dialog({
            id: 'sts-art-anyway', width: 440,
            title: sub ? 'Not recommended for your sensitivity' : 'Not for your skin type',
            body: why,
            buttons: [{ label: 'Add to cart anyway', value: 'yes' }, { label: 'No thanks', value: 'no', outline: true }],
            /* The same ! octagon and Note toggle as the product page's confirm. */
            onOpen: function (n) { if (P.notFor) P.notFor(n.querySelector('.sts-pop__title'), n.querySelector('.sts-pop__body')); },
            onClose: function (v) { done(); resolve(v === 'yes'); }
          });
        }
      });
    });
  }

  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-sts-art-add]')) return;
    if (!w.fetch || !w.FormData || !w.Promise) return;
    e.preventDefault();

    var box = form.closest('.sts-art-callout');
    var fit = box ? box.getAttribute('data-sts-fit') : '';
    var barred = fit === 'barred' || fit === 'subtype';
    var btn = e.submitter || form.querySelector(barred ? '[data-sts-art-anyway]' : 'button');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var nft = form.querySelector('[data-sts-art-nft]');
    if (btn.hasAttribute('data-sts-art-anyway')) {
      askAnyway(box).then(function (ok) {
        if (!ok) return;
        if (nft) { nft.value = String((w.STS && w.STS.state && w.STS.state.type) || d.documentElement.getAttribute('data-sts-type') || 'yes'); nft.disabled = false; }
        addFrom(form, btn, box);
      });
      return;
    }
    if (nft) { nft.value = ''; nft.disabled = true; }
    addFrom(form, btn, box);
  });

  function addFrom(form, btn, box) {
    var status = box && box.querySelector('[data-sts-art-add-status]');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    var action = form.getAttribute('action') || '/cart/add';
    var cartUrl = action.replace(/\/add\/?$/, '') || '/cart';

    btn.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';

    w.fetch(action + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); });
      })
      .then(function (item) {
        btn.removeAttribute('aria-busy');
        btn.textContent = 'Added';
        w.clearTimeout(btn.__stsT);
        btn.__stsT = w.setTimeout(function () { btn.textContent = label; }, 2500);
        if (status) {
          status.textContent = 'Added to your cart. ';
          var link = d.createElement('a');
          link.href = cartUrl;
          link.textContent = 'View cart';
          status.appendChild(link);
        }
        d.dispatchEvent(new CustomEvent('sts:cart:added', { detail: item }));
        return announceCart(cartUrl);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        if (err && err.description && status) {
          status.textContent = String(err.description);
          return;
        }
        form.submit();
      });
  }
}());
